import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.neutral.gray[400]};
  height: 1px;
  width: 96.5%;
`;

export const ContainerReports = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  iframe {
    grid-area: iframe;
    width: 100%;
    height: 100%;
  }
`;

export const ContainerIframe = styled.div`
  margin-top: 0px;
  margin-left: 0px;
`;
